module.exports = __webpack_public_path__ + "img/filter-type-butt--active.0514d5cc.svg";